// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}

.test-detail-title {
  margin: 0 0 0.55rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3f4954;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.test-detail-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.65rem 1rem;
}

.test-detail-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.test-detail-label {
  margin: 0;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/test-details/job-request-test-api-fluid-loss-detail.component.scss"],"names":[],"mappings":"AAAA;EAAuB,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AAKxF;;AAJA;EAAqB,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;EAAgB,yBAAA;EAA2B,sBAAA;AAa3H;;AAZA;EAAsB,aAAA;EAAe,2DAAA;EAA6D,iBAAA;AAkBlG;;AAjBA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,WAAA;AAuB5D;;AAtBA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,WAAA;EAAa,gBAAA;AA6BjE","sourcesContent":[".test-detail-section { border: 1px solid #e3e8ef; border-radius: 4px; padding: 0.65rem; background: #ffffff; }\n.test-detail-title { margin: 0 0 0.55rem; font-size: 0.85rem; font-weight: 700; color: #3f4954; text-transform: uppercase; letter-spacing: 0.02em; }\n.test-detail-fields { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 0.65rem 1rem; }\n.test-detail-field { display: flex; flex-direction: column; gap: 0.3rem; }\n.test-detail-label { margin: 0; font-size: 0.85rem; color: #555; font-weight: 600; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
